<span>
  Pizza party!!! 🍕
</span>
